import axios from 'axios'
export const api = axios.create();
api.interceptors.request.use(function (config) {
    config.baseURL =  process.env.LMS_URL
    return config
})
const lmsData = {
    getProgress: (arg) => new Promise((resolve, reject) => {
        api.get('/get_course_progress/?username=' + arg.toLowerCase())
          .then(function (response) {
            if(response.error){
              console.log(response.error_message)
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }),
      getTutor: (arg) => new Promise((resolve, reject) => {
        api.get('/get_tutor/?username=' + arg.toLowerCase())
          .then(function (response) {
            if(response.error){
              console.log(response.error_message)
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      }) 
}
export default lmsData


// WEBPACK FOOTER //
// ./src/api/lmsAPI.js